module.exports = __webpack_public_path__ + "788dc2a27392ceee0ad07261e2fa4a98.MP3";